<template>
  <b-container style="margin-top:90px;" fluid >
        <video-player :options="videoOptions" class="mx-auto" />
  </b-container>
</template>

<script>
import VideoPlayer from "@/components/Interactive/VideoPlayer/VideoPlayer.vue";

export default {
  name: "InteractiveVideo",
  components: {
    VideoPlayer
  },
  props: ["videoId"],
  data() {
    return {
      videoOptions: {
        autoplay: true,
        controls: true,
        vvid: this.videoId,
        sources: [
          {
            src: "",//atob(this.videofile.replace("_", "/").replace("-", "+")),
            type: "video/mp4"
          }
        ]
      }
    };
  }
};
</script>
<style scoped>
</style>